import type { QUnitType } from 'dayjs';
import dayjs from 'dayjs';

import TranslatorServiceInstance from '@services/TranslatorService';
import { dateToString, parseDate } from '@utilities/dateTime';

export const dateWordTags = {
  days: 'time_days_ago',
  day: 'time_day_ago',
  hours: 'time_hours_ago',
  hour: 'time_hour_ago',
  less_hour: 'time_less_hour_ago',
  minutes: 'time_minutes_ago',
  minute: 'time_minute_ago',
  time_now: 'time_now',
};
export default class TimeAgoPlugin {
  opt: any;
  dom: HTMLElement;
  thresholds: {
    s: number; // seconds to minute
    ss: number; // seconds to minutes
    m: number; // minutes to hour
    mm: number; // minutes to hours
    h: number; // hours to day
    hh: number; // hours to days
    d: number; // days to month
    dd: number; // days to months
    dy: number; // days to year
    dyy: number;
  };

  constructor(dom: HTMLElement, o) {
    const defaults = {
      targetDate: '',
      dateFormat: '',
    };

    this.opt = {
      ...defaults,
      ...o,
    }; //options

    this.dom = dom;

    this.thresholds = {
      s: 59,
      ss: 119,
      m: 59,
      mm: 119,
      h: 23,
      hh: 47,
      d: 29,
      dd: 59,
      dy: 364,
      dyy: 729,
    };
  }

  get dateLocal() {
    return parseDate(this.opt.targetDate);
  }

  async init() {
    if (!this.opt.targetDate) return;

    await this.setTimeAgo();
  }

  async setTimeAgo() {
    const strResult = await this.getString();
    this.dom.innerText = strResult;
  }

  getString() {
    const days = this.calcDiff('day');

    if (this.opt.max === 0 || days > this.opt.max) {
      return dateToString(this.dateLocal, this.opt.dateFormat);
    }

    //years
    if (days > this.thresholds.dy) {
      if (days > this.thresholds.dyy) {
        return this.getAgoTranslation('years', this.calcDiff('year').toString());
      }
      return this.getAgoTranslation('year');
    }

    if (days > this.thresholds.d) {
      if (days > this.thresholds.dd) {
        return this.getAgoTranslation('months', this.calcDiff('month').toString());
      }
      return this.getAgoTranslation('month');
    }

    const hours = this.calcDiff('hour');
    if (hours > this.thresholds.h) {
      if (hours > this.thresholds.hh) {
        return this.getAgoTranslation('days', days.toString());
      }
      return this.getAgoTranslation('day');
    }

    const minutes = this.calcDiff('minute');
    const seconds = this.calcDiff('second');
    if (seconds > this.opt.min && minutes > this.thresholds.m) {
      if (minutes > this.thresholds.mm) {
        return this.getAgoTranslation('hours', hours.toString());
      }
      return this.getAgoTranslation('hour');
    }

    if (seconds > this.opt.min && seconds > this.thresholds.s) {
      if (seconds > this.thresholds.ss) {
        return this.getAgoTranslation('minutes', minutes.toString());
      }
      return this.getAgoTranslation('minute');
    }

    return this.getAgoTranslation('time_now');
  }

  calcDiff(ymwd: QUnitType) {
    return dayjs().diff(this.dateLocal, ymwd);
  }

  getAgoTranslation(val: string, replace?: string) {
    return TranslatorServiceInstance.getText(dateWordTags[val], { replace });
  }
}
